import React from 'react'

import styles from './Notice.module.scss'

const Notice = ({ children }) => <div className={styles.notice}>{children}</div>

export default Notice
